<div fxLayout="row wrap">
  <div class="teranet-padding" fxFlex="100" fxLayout="column">
    <Teranet-PageTitle [PageTitle]="'Holiday'"></Teranet-PageTitle>
    <form [formGroup]="holidayFormGroup"
          #holidayForm="ngForm"
          (ngSubmit)="onSubmit()"
          novalidate>
      <div class="mat-elevation-z4">
        <div fxFlex="100">
          <div fxLayout="column" fxLayoutAlign="center stretch">
            <Teranet-ClientTitle [ClientTitle]="'Holiday Setup'" [IconName]="'calendar'"></Teranet-ClientTitle>
          </div>
          <div fxLayout.xs="column" fxLayout="row wrap">
            <div class="form-group-flex-column">
              <mat-label class="required-field-after">Code</mat-label>
              <mat-form-field appearance="outline">
                <input matInput data-lpignore="true" formControlName="code" required />
                <mat-error *ngIf="holidayFormGroup.get('code').hasError('required') || holidayFormGroup.get('code').hasError('whitespace')">
                  {{ holidayErrorMessage.CODE_REQUIRED }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-group-flex-column">
              <mat-label class="required-field-after">Name</mat-label>
              <mat-form-field appearance="outline">
                <input matInput data-lpignore="true" formControlName="name" required />
                <mat-error *ngIf="holidayFormGroup.get('name').hasError('required') || holidayFormGroup.get('name').hasError('whitespace')">
                  {{ holidayErrorMessage.NAME_REQUIRED }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-group-flex-column">
              <mat-label class="required-field-after">Description</mat-label>
              <mat-form-field appearance="outline">
                <input matInput #txtEmailVal data-lpignore="true" formControlName="description" required />
                <mat-error *ngIf="holidayFormGroup.get('description').hasError('required') || holidayFormGroup.get('description').hasError('whitespace')">
                  {{ holidayErrorMessage.DESCRIPTION_REQUIRED }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutAlign="end">
            <button mat-raised-button class="plain-button-lg" type="reset">Reset</button>
            <button mat-raised-button class="theme-button-lg" type="submit">Add</button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="teranet-padding-relative" fxFlex="100">
    <ngx-spinner [fullScreen]="false"
                 type="ball-clip-rotate-multiple"
                 bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"></ngx-spinner>
    <Teranet-CustomizedGrid [data]="holidayModels"
                            [gridName]="'holiday-list'"
                            [gridSettings]="gridSettings"
                            [initialGridSettings]="gridDefaultSettings()"
                            [isFinishLoading]="true"
                            [isExportExcel]="false"
                            [pageName]="'holiday-list'"></Teranet-CustomizedGrid>
  </div>
</div>
